import React from 'react'
import { UiComponents, ArrowRight, CancelSolidIcon } from '@simulanisindia/ui'

const { SimToggleSwitch } = UiComponents;

const Notifications = () => {

    return (
        <>
            <div className='d-flex align-items-center justify-content-end gap-2'>
                <button className='d-flex align-items-center gap-2 mb-3 redButton '> <CancelSolidIcon /> Terminate All Sessions</button>
            </div>
            <div className="carddata colorborder">
                <div className='profileinfo'>
                    <div>
                        <h6>Preferences</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                </div>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>Skill Bridge XR</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                    <span className='cursor-pointer'><ArrowRight /></span>
                </div>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>Skill Bridge XR</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                    <span className='cursor-pointer'><ArrowRight /></span>
                </div>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>Skill Bridge XR</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                    <span className='cursor-pointer'><ArrowRight /></span>
                </div>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>Skill Bridge XR</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                    <span className='cursor-pointer'><ArrowRight /></span>
                </div>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>Preferences</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                </div>

                <p>Email notifications</p>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>New sign-in to account alert</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                    <SimToggleSwitch />
                </div>
                <div className='profileinfo mt-2'>
                    <div>
                        <h6>Newsletter subscription</h6>
                        <p>Manage your preferences for Email and Application-Specific notifications.</p>
                    </div>
                    <SimToggleSwitch />
                </div>

            </div>
        </>
    )
}

export default Notifications
